import { useToggleOnAir } from '@/scenarios/legacy-player/hooks/useToggleOnAir';

import { useActiveTabController } from '../../feature-player/hooks/controller/use-active-tab-controller';

export const useLiveActiveTabController = () => {
    const { returnToAir, pause } = useToggleOnAir();

    useActiveTabController({ play: returnToAir, pause });
};
